/* @ngInject */
function CampaignActionItemController ($scope, $translate, Utils) {
  $scope.actionTypes = {
    ART: 'arts',
    POST: 'posts',
    AUDIT: 'audit'
  }

  $scope.publicationLabels = {
    SCHEDULED: $translate.instant('campaignEdit.actions.scheduled'),
    PUBLISHED: $translate.instant('campaignEdit.actions.published'),
    EXPIRED: $translate.instant('campaignEdit.actions.expired')
  }

  $scope.publicationColors = {
    SCHEDULED: 'yellow',
    PUBLISHED: 'green',
    EXPIRED: 'orange'
  }

  const api = {

  }

  this.getApi = () => api

  $scope.getActionTitle = (title) => {
    if (!title) {
      return $translate.instant('campaignEdit.actions.newAction')
    }
    return Utils.truncateText(title, 30)
  }
}

export { CampaignActionItemController }
